import React from 'react'
import { Select } from '../Forms'

export const SelectFilter = ({
  onChange,
  options,
  value,
  width,
}: {
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  options: { value: string; label: string; disabled?: boolean }[]
  value: any
  width?: number
}) => (
  <Select
    onChange={onChange}
    placeholder=" "
    size="sm"
    value={value}
    maxWidth={width}
    width={width}
  >
    {options.map(({ value, label, disabled }) => (
      <option key={value} value={value} disabled={disabled}>
        {label}
      </option>
    ))}
  </Select>
)
